// Module
var code = "<button type=\"button\" class=\"OneLineThumbnailSelector\">\n  <div class=\"embed-responsive embed-responsive-16by9\">\n    <img alt=\"...\" class=\"embed-responsive-item\" />\n  </div>\n  <div class=\"OneLineThumbnailSelector__caption\">\n    <h3></h3>\n  </div>\n</button>\n";
// Exports
export default code;